import { authHeaders, client } from '../../_shared/services/openapiClient';
import type { paths } from '../../../types/schema';

export type UserPreferences = NonNullable<
  paths['/api/v1/users/update_preferences']['post']['requestBody']
>['content']['application/json'];

export type UserPreferencesResponse =
  paths['/api/v1/users/preferences']['get']['responses'][200]['content']['application/json'];

export type FollowUserResponse =
  paths['/api/v1/user_profiles/{user_profile_id}/follow']['post']['responses'][200]['content'];

export type EnterInviteCodeResponse =
  paths['/api/v1/users/invited']['post']['responses'][200]['content']['application/json'];

export type UserInvitationRecapResponse =
  paths['/api/v1/users/invitation_recap']['get']['responses'][200]['content']['application/json']['invitationRecap'];

export type UserInfoResponse =
  paths['/api/v1/users']['get']['responses'][200]['content']['application/json']['user'];

export async function getUserInfo(): Promise<UserInfoResponse> {
  const { data, error } = await client.GET('/api/v1/users', {
    headers: authHeaders()
  });
  if (error) throw error;
  if (!data) throw new Error('Empty response from getUserInfo');
  return data.user;
}

export async function getUserPreferences() {
  const { data, error } = await client.GET('/api/v1/users/preferences', {
    headers: authHeaders()
  });
  if (error) throw error;
  if (!data) throw new Error('Empty response from getUserPreferences');

  return data;
}

export async function updateUserPreferences(preferences: UserPreferences) {
  const { data, error, response } = await client.POST('/api/v1/users/update_preferences', {
    body: preferences,
    headers: authHeaders()
  });
  if (error) throw error;
  if (!data) throw new Error('Empty response from updateUserPreferences');
  return response;
}

export async function followUser(
  myProfileId: string,
  userProfileId: string
): Promise<FollowUserResponse> {
  const { error } = await client.POST('/api/v1/user_profiles/{user_profile_id}/follow', {
    params: { path: { user_profile_id: myProfileId } },
    body: {
      user_profile: {
        user_profile_id: userProfileId
      }
    },
    headers: authHeaders()
  });
  if (error) throw error;
}

export async function spendInviteCode(inviteCode: string): Promise<EnterInviteCodeResponse> {
  const { data, error } = await client.POST('/api/v1/users/invited', {
    body: {
      user: {
        invitation_code: inviteCode
      }
    },
    headers: authHeaders()
  });
  if (error) throw error;
  if (!data) throw new Error('Empty response from spendInviteCode');
  return data;
}

export async function getUserInvitationRecap(): Promise<UserInvitationRecapResponse> {
  const { data, error } = await client.GET('/api/v1/users/invitation_recap', {
    headers: authHeaders()
  });
  if (error) throw error;
  if (!data) throw new Error('Empty response from getUserInvitationRecap');
  return data.invitationRecap;
}